/**
 * This package's translations, registered at import.
 *
 * French and English, like the other product features: the product is French
 * and English is the parity reference i18next falls back to.
 *
 * The vocabulary here is deliberately the *contract's* and not any ERP's.
 * "Système externe", "connecteur", "entité", "sens" — a screen that said
 * "Sage" would have to be retranslated the day an installation runs something
 * else, and the code underneath would not have changed at all.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "integration";

registerNamespace(NAMESPACE, { en, fr });
